import { QueryClient, UseMutationResult } from 'react-query';
import { getVenueMenuByIdApi, menuBulkCopyApi } from '../constants/apiEndPoints';
import HttpServiceHelper from './httpServiceHelper';
import { _HttpMethods, _Payload } from '../constants/staticTypes';
import { TreeNode } from 'primereact/treenode';
import { TreeTableSelectionKeysType } from 'primereact/treetable';
import { AxiosResponse } from 'axios';
import { getErrorMessage } from '../utils/common';
import { AlertVariant } from '../constants/constants';

export const getVenueFbMenu = (queryClient: QueryClient, xTenantId?: string) => {
    let url = `${getVenueMenuByIdApi}`;

    return HttpServiceHelper({
        url,
        method: _HttpMethods.POST,
        queryClient,
        data: {
            id: xTenantId,
        },
    });
};

export const getItemPriceString = (itemPrices: any[]) => {
    return itemPrices.map((itemPrice) => `$${itemPrice.fieldValue}`).join(', ');
};

export const transformMenuDataToTreeTable = (menuData: any) => {
    return menuData.map((menu: any) => ({
        key: menu.id,
        data: {
            name: menu.categoryName,
            // type: 'Menu',
        },
        label: menu.categoryName,
        children:
            menu.subCategory?.map((sub: any) => ({
                key: sub.id,
                data: {
                    name: sub.categoryName,
                    // type: 'Category',
                },
                label: sub.categoryName,
                children:
                    sub.menuItems?.map((item: any) => ({
                        key: item.id,
                        data: {
                            name: item.itemName,
                            type: item.itemType ?? 'Item',
                            isActive: item.isActive ? 'Yes' : 'No',
                            itemPrices: item.itemPrices.length > 0 ? getItemPriceString(item.itemPrices) : null,
                        },
                        label: item.itemName,
                    })) || [],
            })) || [],
    }));
};

// build menu payload for bulk copy
export const buildMenuPayload = (nodes: TreeNode[], selectedKeys: TreeTableSelectionKeysType) => {
    const menus: any[] = [];

    const isChecked = (key: string) => {
        const value = selectedKeys[key];
        if (typeof value === 'object') {
            return value.checked;
        }
        return !!value; // for boolean true
    };

    for (const menuNode of nodes) {
        const menuId = menuNode.key as string;

        const menuIsChecked = isChecked(menuId);
        const subcategories: any[] = [];

        for (const subcategoryNode of menuNode.children || []) {
            const subcategoryId = subcategoryNode.key as string;
            const subcategoryIsChecked = isChecked(subcategoryId);
            const menuItems: string[] = [];

            for (const menuItemNode of subcategoryNode.children || []) {
                const menuItemId = menuItemNode.key as string;
                if (isChecked(menuItemId)) {
                    menuItems.push(menuItemId);
                }
            }

            if (subcategoryIsChecked || menuItems.length > 0) {
                subcategories.push({
                    subcategory_id: subcategoryId,
                    menu_items: menuItems,
                });
            }
        }

        if (menuIsChecked || subcategories.length > 0) {
            menus.push({
                menu_id: menuId,
                subcategories,
            });
        }
    }

    return { menus };
};

export type _BulkCopyPayloadType = {
    tenantId: string;
    newTenantId: string;
    menus: any[];
};

export const bulkCopyMenuItems = (
    menuBulkCopyMutation: UseMutationResult<AxiosResponse<any, any>, unknown, _Payload, unknown>,
    param: _BulkCopyPayloadType,
    onSuccess: (data: any) => void,
    onError: (res: string, variant: string) => void
) => {
    menuBulkCopyMutation.mutate(
        {
            url: menuBulkCopyApi,
            method: _HttpMethods.POST,
            data: param,
        },
        {
            onSuccess: (res) => onSuccess(res.data),
            onError: (res) => onError(getErrorMessage(res), AlertVariant.ERROR),
        }
    );
};
